import { AuthProvider } from '@refinedev/core';
import { api } from './utils/api';
import i18n from 'i18next';

export const TOKEN_KEY = 'auth';
export const USER_KEY = 'user';

export const authProvider: AuthProvider = {
    login: async ({ username, password }) => {
        try {
            const url = username ? '/api/auth/login' : '/api/auth/login-crypto';
            const { data, status } = await api.post(url, {
                user_name: username,
                password,
            });

            if (status === 200 && data?.access_token) {
                localStorage.setItem(TOKEN_KEY, data.access_token);
                if (data?.user) {
                    localStorage.setItem(USER_KEY, JSON.stringify(data.user));
                    window.dispatchEvent(new Event('userUpdated'));
                }
                return {
                    success: true,
                    redirectTo: '/',
                };
            }

            return {
                success: false,
                error: {
                    name: i18n.t('notifications.Login Error'),
                    message: data?.message || 'Login Failed',
                },
            };
        } catch (e: any) {
            return {
                success: false,
                error: {
                    name: i18n.t('notifications.Login Error'),
                    message: e?.message || 'Login Failed',
                },
            };
        }
    },

    logout: () => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        window.location.href = '/login';
        return Promise.resolve({ success: true });
    },

    getPermissions: () => {
        return Promise.resolve();
    },

    getIdentity: async () => {
        const userRaw = localStorage.getItem(USER_KEY);
        if (!userRaw) return Promise.reject();

        try {
            const user = JSON.parse(userRaw);
            return Promise.resolve(user);
        } catch {
            return Promise.reject();
        }
    },

    check: async () => {
        const token = localStorage.getItem(TOKEN_KEY);
        return token
            ? { authenticated: true }
            : { authenticated: false, redirectTo: '/login' };
    },

    onError: async error => {
        if (error?.status === 401 || error?.status === 403) {
            return { logout: true, redirectTo: '/login' };
        }
        return {};
    },
};
